var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/RegularInvestmentPlanConstants.js');
var ActionTypes = Constants.ActionTypes;

module.exports = {
    validateRegularInvestmentPlan: function (ripOption, productId, userType, accountType, investorOIN) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.VALIDATE_REGULAR_INVESTMENT_PLAN,
            productId: productId,
            ripOption: ripOption,
            userType: userType,
            accountType: accountType,
            investorOIN: investorOIN
        });
    },
    updateRIPInvestAllocationQty: function (index, weight) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_RIP_INVEST_ALLOCATION_QTY,
            index: index,
            weight: weight
        });
    },
    monthlyAmountAllocation: function (option) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.MONTHLY_AMOUNT_ALLOCATION,
            option: option
        });
    },
    updateRIPData: function (field, value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_RIP_DATA,
            field: field,
            value: value
        });
    },
    updateRegularInvestmentPlan: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_REGULAR_INVESTMENT_PLAN,
            data: data
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/RegularInvestmentPlanActions.js